/**
 * Created by Christof Sander on 07.02.2017.
 */

const utils = require('../lib/utils');
const MD5 = require('md5.js');
window.jQuery = window.$ = utils.$ = require('jquery');
utils.i18next.wrapper = require('./i18next');

utils.md5 = function(data){
    return new MD5().update(data).digest('hex')
}

/**
 * uses navigator clipboard api to copy some string to the clipboard if possible.
 * @see https://w3c.github.io/clipboard-apis/#navigator-clipboard
 * @see https://developer.mozilla.org/en-US/docs/Web/API/isSecureContext
 *
 * @param data                      string - data to copy to clipboard.
 * @param showPanelMessage          boolean - show status controllerPanelMessage if possible
 * @returns {Promise<boolean>}      boolean - success
 */
utils.copyToClipboard = async function(data, showPanelMessage = true){
    let success = true

    // check preconditions
    const storage = (window || {}).storage
    if(!data){
        console.error('utils.copyToClipboard() - missing data')
        success = false
    } else if(!(storage || {}).app){
        console.error('utils.copyToClipboard() - missing storage')
        success = false
    } else if(!(navigator || {}).permissions || !(navigator || {}).clipboard){
        if(isSecureContext){
            console.error('utils.copyToClipboard() - missing clipboard api')
        } else {
            console.error('utils.copyToClipboard() - missing clipboard api due to insecure context. are your running on https?')
        }
        success = false
    }
    // check if user grants clipboard usage
    else if(storage.app.copyToClipboardGranted === undefined){
        storage.app.copyToClipboardGranted = false
        try {
            const permissionStatus = await navigator.permissions.query({ name: 'clipboard-write' }) || {}
            if(permissionStatus.state === 'granted'){
                storage.app.copyToClipboardGranted = true
            } else if(permissionStatus.state === 'prompt') {
                delete storage.app.copyToClipboardGranted
                return
            }
        } catch(error){
            console.error('utils.copyToClipboard() - permissions error', error)
            success = false
        }
    }

    // copy to clipboard
    if(storage.app.copyToClipboardGranted){
        try {
            await navigator.clipboard.writeText(data)
            success = true
        } catch(error){
            console.error('utils.copyToClipboard() - copy error', error)
            success = false
        }
    }

    // show panel message if necessary
    if(showPanelMessage){
        let statusController = getComponent('statusController')
        if(statusController){
            if(success){
                statusController.addPanel('status.done.copyToClipboard');
            } else {
                statusController.addPanel('status.problem.copyToClipboard');
            }
        }
    }

    return success
}

/**
 * downloads a given file url via a temporary a-dom-element.
 *
 * @param url       string - url to download (has to be a GETTER)
 * @param filename  string - client side filename for the new file
 */
utils.downloadFile = function(url, filename){
    const a = document.createElement('a')
    a.href = url
    a.download = filename || ''
    document.body.appendChild(a)
    a.click()
    a.remove()
}

module.exports = utils;
